module.exports = __webpack_public_path__ + "./images/blue_thumb.9cd7f3.jpg";